import React from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import SvgBook from '../components/icons/book'
import SvgArrowRed from '../components/icons/arrow_red'
import { clientAction } from '../reducers/restApi'
import { withStyles, withWidth } from '@material-ui/core'
import { connect } from 'react-redux'

const styles = theme => ({
  // root: {
  //   width: '100%',
  //   marginTop: theme.spacing.unit * 3,
  //   overflowX: 'auto',
  //   // maxWidth: "800px",
  // },
  brown: {
    color: '#623F2A'
  },
  mocha: {
    color: '#CA8456'
  },
  lightbrown: {
    color: '#EBBC8D'
  },
  tan: {
    color: '#D58F6D'
  },
  beige: {
    color: '#EEC5AD'
  },
  lihgttan: {
    color: '#F7E0D5'
  },

  table: {
    // minWidth: 700,
  },
  title: {
    flex: '0 0 auto',
    margin: '10px'
  },
  tableCell: {
    whiteSpace: 'nowrap',
    padding: '3px 16px 3px 14px'
  },
  locationCell: {
    padding: '3px 16px 3px 14px'
  },
  dateCell: {
    width: '70px',
    padding: '3px 16px 3px 14px'
  },
  refreshButton: {
    color: 'green',
    width: '100%',
    height: '100%'
  },
  formElement: {
    width: '100%'
  },
  tablePaper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  formContainer: {
    margin: 10
  },
  spacingContainer: {
    padding: theme.spacing(2),
  },
  addContainer: {
    flexDirection: 'row-reverse',
    flex: 1,
    textAlign: 'right',
    paddingRight: '1em'
  },
  deleteButton: {
    backgroundColor: 'red'
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  tileImage: {},
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: theme.palette.background.paper,
    width: '100%',
    height: '100%',
    maxWidth: 900,
    margin: '0 auto 100px auto',

  },
  gridList: {
    width: '100%',
    height: '100%',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)'
  },
  titleBar: {
    width: '100%'
  },
  card: {
    width: '50%',
    padding: 10,
  },
  cardHeader: {
    width: '100%',
    // color: 'white',
    // backgroundColor: '#d80000',
    padding: '15px 40px',
    textAlign: 'left',

    textTransform: 'uppercase',
    fontSize: 20
  },
  cardPreviewImg: {
    width: '50%',
    display: 'inline-flex'
  },
  cardPreviewBlurb: {
    width: '100%',
    borderRadius: 19,
    // backgroundColor: '#D58F6D',
    // color: 'white',
    textAlign: 'justify',
    padding: 50
  },
  blurbContainer: {
    '& hr': {
      backgroundColor: 'black',
      height: 5,
      width: 150,
      margin: '30px 0px'
    }
  },
  cardLink: {
    backgroundColor: 'white',
    color: '#623F2A',
    borderRadius: 0,
    textDecoration: 'none',
    fontSize: 16,
    fontWeight: 'bold',
  },
  cardImage: {
    width: '100%',
    margin: 'auto'
  },
  imgContainer: {
    height: 300,
    display: 'flex'
  },
  cardContent: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center'
  },
  linkButton: {
    textDecoration: 'none',
  },
  imgIcon: {
    height: '100%'
  },
  leftBook: {
    width: '50%',
    height: 500,
    backgroundColor: '#CA8456',
    textAlign: 'center',
    marginBottom: 110,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  bookIcon: {
    width: 300,
    height: 300,
  },
  listHeader: {},
  rightHeader: {
    width: '50%',
    display: 'inline-block',
    transform: 'translateY(-100px)',
  },
  underlineText: {
    textDecoration: 'underline',
  },
  findTools: {
    // width: 919,
    width: '80%',
    transform: 'translateX(-23%)',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.22)',
    color: '#d80000',
    backgroundColor: '#ffffff',
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
    marginTop: 10,
    padding: 10,
    lineHeight: 1.64
  },
  toolsHeader: {
    // width: 919,
    width: '80%',
    transform: 'translateX(-23%)',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.22)',
    color: '#623F2A',
    backgroundColor: '#ffffff',
    fontSize: '0.6rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'justify',
    padding: 50,
    // marginTop: 50,
    lineHeight: 1.47

  },
  scrollToDiscover: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.22)',
    color: '#623F2A',
    backgroundColor: '#ffffff',
    fontSize: 36,
    textAlign: 'center',
    transform: 'translateY(-50%)',
    margin: 'auto',
    maxWidth: 900,
    padding: 10,
    marginTop: -110,
    marginBottom: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  scrollToDiscoverInner: {
    fontSize: 36,
    display: 'inline-flex',
    lineHeight: 1.7,
    height: 50
  },
  arrowDown: {
    width: 30,
    margin: '0px 20px',
    transform: 'rotate(-90deg)',
  },
  arrowRight: {
    height: 20,
    width: 20,
    margin: 5,
    transform: 'rotateY(180deg)',
  }
})

class ArticleList extends React.Component {
  state = {
    dialogOpen: false,
    directoryDialogOpen: false,
    dialogConfirmationOpen: false,
    dialogDirectoryConfirmationOpen: false,
    selectedId: null,
    directorySelectedId: null,
    detailsOpen: null,
    path: []
  }

  componentDidMount () {
    this.props.listArticle()
  }

  handleClose () {
    this.setState({ dialogOpen: false, selectedId: null })
  }

  handleEdit (id) {
    let item = this.props.files.data[id].instance
    this.props.initializeForm(item)
    this.setState({ dialogOpen: true, selectedId: id })
  }

  handleAdd () {
    this.props.initializeForm({})
    this.setState({ dialogOpen: true, selectedId: null })
  }

  showDetails = (item) => () => {
    console.log(item)
    this.setState({ detailsOpen: item })
  }
  hideDetails = () => {
    this.setState({ detailsOpen: null })
  }

  selectItem (tile) {
    if (tile.mimetype === undefined) {
      let newPath = this.state.path.slice()

      if (tile.name === '..') {
        if (newPath.length >= 0) {
          newPath.pop()
        }
      } else {
        newPath.push(tile.name)
      }
      this.setState({ path: newPath })
    } else {
      // file
      window.open(tile.url, '_blank')
    }
  }

  render () {
    let {
      classes,
      // files,
      // directory,
      article,
      // ...props
    } = this.props

    return (<div>
        <div className={classes.listHeader}>
          <div className={classes.leftBook}>
            {/*<SVGInline svg={book}/>*/}
            <SvgBook className={classes.bookIcon}/>
          </div>
          <div className={classes.rightHeader}>
            {/*<div className={classes.findTools}>*/}
            {/*  HERE YOU CAN FIND OUR TOOLS*/}
            {/*</div>*/}
            {/*<div className={classes.findTools}>*/}
            {/*  FOR EXPERIENTIAL LEARNING*/}
            {/*</div>*/}
            <div className={classes.toolsHeader}>
              these TOOLS ARE a pilot educational experiment, based on the EVENTS THAT WERE ORGANIZED IN DIFFERENT
              PLACES
              IN EUROPE in the frame of this project.

              <br/>
              <br/>
              the focus of the tools is in <span className={classes.underlineText}>THE LEGACY OF TRAUMATIC
            HISTORIC EVENTS</span> and the attempt to seize the lessons learnt in a broader terms both
              geographically and thematically.

              <br/>
              <br/>
              Tools were developed under the financial support of european commission and can be used
              free of charge by individuAls and institutions and freely distributed for the purposes of
              education and learning. the reference to the project should be provided.

            </div>
          </div>
        </div>
        <div className={classes.scrollToDiscover}>
          <Typography className={classes.scrollToDiscoverInner}>
            SCROLL TO DISCOVER TOOLS
          </Typography>
          <SvgArrowRed className={classes.arrowDown}/>
        </div>
        {/*<HowToUse/>*/}
        <div className={classes.root}>
          {article && article.index && article.index.map(i => {
            let o = article.data[i].instance
            return <div key={o.id} className={classes.card}>
              <div className={classes.imgContainer}>
                <img src={o.image} className={classes.cardImage} alt="article"/>
              </div>
              <Typography variant={'h4'} className={classes.cardHeader}>
                {o.title}
              </Typography>
              <div className={classes.cardPreviewBlurb}>
                <div className={classes.blurbContainer} dangerouslySetInnerHTML={{ __html: o.formatted_blurb }}></div>
                <Link to={`/tabs/article/${o.id}`} className={classes.linkButton}>
                  <Button size="small" className={classes.cardLink}>
                    EXPLORE THE TOOL
                    <SvgArrowRed className={classes.arrowRight}/>
                  </Button>
                </Link>
              </div>
            </div>
          })}
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => (
    {
      schema: state.schema.schema,
      article: state.restApi.article,
    }
  ),

  (dispatch) => ({
    listArticle: () => dispatch(clientAction(['article', 'list'])),
  })
)(withWidth()(withStyles(styles)(ArticleList)
))

